import type { EditorialCategory } from '../../types/news'
import { secondaryNewsCategories } from '../../services/news/presentation'
import { getNewsCategoryConfig } from './newsCategoryConfig'

export function ArticleSignals({ categories, tickers }: { categories: EditorialCategory[]; tickers: string[] }) {
  const secondaryCategories = secondaryNewsCategories(categories)
  if (!secondaryCategories.length && !tickers.length) return null

  return <div className="news-card-signals">
    {secondaryCategories.length > 0 && <div className="news-card-tags" aria-label="Connected infrastructure">
      {secondaryCategories.map((category) => {
        const config = getNewsCategoryConfig(category)
        const Icon = config.icon
        return <span key={category}><Icon size={13} strokeWidth={1.65} aria-hidden="true"/>{config.label}</span>
      })}
    </div>}
    {tickers.length > 0 && <div className="news-card-tickers" aria-label="Companies mentioned">
      {tickers.map((ticker) => <span key={ticker}>${ticker}</span>)}
    </div>}
  </div>
}
